import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, Route } from 'react-router-dom';
import Nav from 'app/pages/Notifications/Nav';
import { Container, LeftContent, RightContent } from 'app/components/LeftNav';
import NotificationsList from 'app/pages/Notifications/NotificationsList/NotificationsList';
import ManageSubscriptions from 'app/pages/Notifications/ManageSubscriptions/ManageSubscriptions';
export default function Notifications({ match }) {
    return (_jsxs(Container, { children: [_jsx(LeftContent, { children: () => _jsx(Nav, { match: match }) }), _jsx(RightContent, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: `${match.url}/all`, component: () => _jsx(NotificationsList, {}) }), _jsx(Route, { exact: true, path: `${match.url}/manage`, component: () => _jsx(ManageSubscriptions, {}) })] }) })] }));
}
